module.exports = __webpack_public_path__ + "img/630d425dac6faecc1918ee688f40e07c.491ee235.png";